import { AppLanguage, getPreferredLanguage } from '../language';

export interface UserProfileI18nTemplate {
  ui: {
    loading: string;
    errorPrefix: string;
    userNotFound: string;
    back: string;
    username: string;
    phone: string;
    password: string;
    loginMethods: string;
    passwordLogin: string;
    googleLogin: string;
    wechatLogin: string;
    configured: string;
    notConfigured: string;
    bind: string;
    unbind: string;
    processing: string;
    setPassword: string;
    edit: string;
    cancel: string;
    confirmUpdate: string;
    confirmSet: string;
    token: string;
    tokenGet: string;
    tokenCopy: string;
    tokenHint: string;
    createdAt: string;
    timezone: string;
    unit: string;
    language: string;
    currency: string;
    logout: string;
    boundWithPrefix: string;
    unbindGuardMessage: string;
    usernamePlaceholder: string;
    usernamePopupPlaceholder: string;
    newPasswordPlaceholder: string;
    confirmNewPasswordPlaceholder: string;
    passwordPlaceholder: string;
    passwordConfirmPlaceholder: string;
    unitSaved: string;
    currencySaved: string;
    languageSaved: string;
    timezoneSaved: string;
    logoutFailed: string;
    profileFetchFailed: string;
    serverUnavailable: string;
    usernameRequired: string;
    usernameInvalid: string;
    usernameUpdateSuccess: string;
    usernameUpdateFailed: string;
    usernameUpdateRetry: string;
    tokenFetchSuccess: string;
    tokenFetchFailed: string;
    tokenFetchError: string;
    tokenEmpty: string;
    tokenCopySuccess: string;
    tokenCopyFailed: string;
    bindGoogleNoToken: string;
    bindGoogleSuccess: string;
    bindGoogleFailed: string;
    bindGoogleRetry: string;
    googleLoginFailed: string;
    unbindSuccess: string;
    unbindFailed: string;
    unbindRetry: string;
    wechatMissingAppId: string;
    userInfoUnavailable: string;
    passwordRequired: string;
    passwordMismatch: string;
    passwordMinLength: string;
    setPasswordSuccess: string;
    setPasswordFailed: string;
    setPasswordRetry: string;
    changePasswordNeedUsername: string;
    changePasswordFillAll: string;
    changePasswordMismatch: string;
    changePasswordMinLength: string;
    changePasswordSuccess: string;
    changePasswordFailed: string;
    changePasswordRetry: string;
    unitUS: string;
    unitMetric: string;
    currencyUSD: string;
    currencyCNYPrefix: string;
    timezoneUTC: string;
    timezoneLocal: string;
    timezoneShanghai: string;
    timezoneTokyo: string;
    timezoneLosAngeles: string;
    timezoneNewYork: string;
    timezoneLondon: string;
    timezoneSydney: string;
    timezoneSingapore: string;
  };
}

export const TEMPLATES: Record<AppLanguage, UserProfileI18nTemplate> = {
  zh: {
    ui: {
      loading: '加载中...',
      errorPrefix: '错误',
      userNotFound: '未找到用户信息',
      back: '返回',
      username: '用户名',
      phone: '手机号',
      password: '密码',
      loginMethods: '登录方式',
      passwordLogin: '密码登录',
      googleLogin: 'Google 登录',
      wechatLogin: '微信登录',
      configured: '已设置',
      notConfigured: '未配置',
      bind: '绑定微信',
      unbind: '解绑',
      processing: '处理中...',
      setPassword: '设置密码',
      edit: '修改',
      cancel: '取消',
      confirmUpdate: '确认修改',
      confirmSet: '确认设置',
      token: '用户Token',
      tokenGet: '获取',
      tokenCopy: '复制',
      tokenHint: '点击获取按钮查看',
      createdAt: '账户创建时间',
      timezone: '时区设置',
      unit: '单位设置',
      language: '语言设置',
      currency: '货币设置',
      logout: '退出登录',
      boundWithPrefix: '已绑定：',
      unbindGuardMessage: '解绑前，请先设置密码或绑定其他登录方式',
      usernamePlaceholder: '输入用户名',
      usernamePopupPlaceholder: '请输入你的新用户名',
      newPasswordPlaceholder: '新密码（至少8位）',
      confirmNewPasswordPlaceholder: '确认新密码',
      passwordPlaceholder: '输入密码（至少8位）',
      passwordConfirmPlaceholder: '再次输入密码',
      unitSaved: '单位设置已保存',
      currencySaved: '货币设置已保存',
      languageSaved: '语言设置已保存',
      timezoneSaved: '时区设置已保存',
      logoutFailed: '退出登录失败，请重试',
      profileFetchFailed: '获取用户信息失败',
      serverUnavailable: '无法连接到服务器',
      usernameRequired: '请输入用户名',
      usernameInvalid: '用户名需为3-32位，可包含字母、数字以及 . _ -',
      usernameUpdateSuccess: '用户名修改成功',
      usernameUpdateFailed: '用户名修改失败',
      usernameUpdateRetry: '用户名修改失败，请稍后重试',
      tokenFetchSuccess: '用户Token获取成功',
      tokenFetchFailed: '获取用户Token失败',
      tokenFetchError: '获取用户Token时出现错误',
      tokenEmpty: '暂无可复制的 Token',
      tokenCopySuccess: '用户Token复制成功',
      tokenCopyFailed: '复制失败，请手动复制',
      bindGoogleNoToken: 'Google 绑定失败：未返回令牌',
      bindGoogleSuccess: 'Google 绑定完成',
      bindGoogleFailed: 'Google 绑定失败',
      bindGoogleRetry: 'Google 绑定失败，请稍后重试',
      googleLoginFailed: 'Google 登录失败或已取消',
      unbindSuccess: '解绑完成',
      unbindFailed: '解绑失败',
      unbindRetry: '解绑失败，请稍后重试',
      wechatMissingAppId: '未配置微信 App ID，请联系管理员',
      userInfoUnavailable: '无法获取用户信息',
      passwordRequired: '请输入密码并确认密码',
      passwordMismatch: '两次输入的密码不一致',
      passwordMinLength: '密码长度至少8个字符',
      setPasswordSuccess: '密码设置完成',
      setPasswordFailed: '密码设置失败',
      setPasswordRetry: '密码设置失败，请稍后重试',
      changePasswordNeedUsername: '请先设置用户名再修改密码',
      changePasswordFillAll: '请填写所有密码字段',
      changePasswordMismatch: '两次输入的新密码不一致',
      changePasswordMinLength: '新密码长度至少8个字符',
      changePasswordSuccess: '密码修改成功',
      changePasswordFailed: '密码修改失败',
      changePasswordRetry: '密码修改失败，请稍后重试',
      unitUS: '美制 (lbs, in)',
      unitMetric: '公制 (kg, cm)',
      currencyUSD: '美元 (USD $)',
      currencyCNYPrefix: '人民币 (CNY ¥) - 汇率:',
      timezoneUTC: 'UTC (协调世界时)',
      timezoneLocal: '本地时间',
      timezoneShanghai: '北京/上海 (UTC+8)',
      timezoneTokyo: '东京 (UTC+9)',
      timezoneLosAngeles: '洛杉矶 (UTC-8/-7)',
      timezoneNewYork: '纽约 (UTC-5/-4)',
      timezoneLondon: '伦敦 (UTC+0/+1)',
      timezoneSydney: '悉尼 (UTC+10/+11)',
      timezoneSingapore: '新加坡 (UTC+8)',
    },
  },
  en: {
    ui: {
      loading: 'Loading...',
      errorPrefix: 'Error',
      userNotFound: 'User info not found',
      back: 'Back',
      username: 'Username',
      phone: 'Phone number',
      password: 'Password',
      loginMethods: 'Login methods',
      passwordLogin: 'Password login',
      googleLogin: 'Google login',
      wechatLogin: 'WeChat login',
      configured: 'Configured',
      notConfigured: 'Not configured',
      bind: 'Bind WeChat',
      unbind: 'Unbind',
      processing: 'Processing...',
      setPassword: 'Set password',
      edit: 'Edit',
      cancel: 'Cancel',
      confirmUpdate: 'Confirm',
      confirmSet: 'Confirm',
      token: 'User token',
      tokenGet: 'Get',
      tokenCopy: 'Copy',
      tokenHint: 'Click Get to view',
      createdAt: 'Account created at',
      timezone: 'Timezone',
      unit: 'Unit',
      language: 'Language',
      currency: 'Currency',
      logout: 'Log out',
      boundWithPrefix: 'Bound: ',
      unbindGuardMessage: 'Before unbinding, set a password or bind another login method first',
      usernamePlaceholder: 'Enter username',
      usernamePopupPlaceholder: 'Enter your new username',
      newPasswordPlaceholder: 'New password (at least 8 chars)',
      confirmNewPasswordPlaceholder: 'Confirm new password',
      passwordPlaceholder: 'Enter password (at least 8 chars)',
      passwordConfirmPlaceholder: 'Enter password again',
      unitSaved: 'Unit setting saved',
      currencySaved: 'Currency setting saved',
      languageSaved: 'Language setting saved',
      timezoneSaved: 'Timezone setting saved',
      logoutFailed: 'Logout failed, please try again',
      profileFetchFailed: 'Failed to fetch user info',
      serverUnavailable: 'Unable to connect to server',
      usernameRequired: 'Please enter a username',
      usernameInvalid: 'Username must be 3-32 chars and can include letters, numbers, . _ -',
      usernameUpdateSuccess: 'Username updated',
      usernameUpdateFailed: 'Failed to update username',
      usernameUpdateRetry: 'Username update failed, please try again later',
      tokenFetchSuccess: 'User token fetched',
      tokenFetchFailed: 'Failed to fetch user token',
      tokenFetchError: 'Error while fetching user token',
      tokenEmpty: 'No token to copy',
      tokenCopySuccess: 'User token copied',
      tokenCopyFailed: 'Copy failed, please copy manually',
      bindGoogleNoToken: 'Google bind failed: no token returned',
      bindGoogleSuccess: 'Google bound successfully',
      bindGoogleFailed: 'Google bind failed',
      bindGoogleRetry: 'Google bind failed, please try again later',
      googleLoginFailed: 'Google login failed or canceled',
      unbindSuccess: 'Unbound successfully',
      unbindFailed: 'Unbind failed',
      unbindRetry: 'Unbind failed, please try again later',
      wechatMissingAppId: 'WeChat App ID is not configured. Contact admin',
      userInfoUnavailable: 'Unable to get user info',
      passwordRequired: 'Please enter and confirm password',
      passwordMismatch: 'Passwords do not match',
      passwordMinLength: 'Password must be at least 8 characters',
      setPasswordSuccess: 'Password set successfully',
      setPasswordFailed: 'Failed to set password',
      setPasswordRetry: 'Set password failed, please try again later',
      changePasswordNeedUsername: 'Set a username before changing password',
      changePasswordFillAll: 'Please fill in all password fields',
      changePasswordMismatch: 'New passwords do not match',
      changePasswordMinLength: 'New password must be at least 8 characters',
      changePasswordSuccess: 'Password changed successfully',
      changePasswordFailed: 'Failed to change password',
      changePasswordRetry: 'Password change failed, please try again later',
      unitUS: 'US (lbs, in)',
      unitMetric: 'Metric (kg, cm)',
      currencyUSD: 'US Dollar (USD $)',
      currencyCNYPrefix: 'Chinese Yuan (CNY ¥) - Rate:',
      timezoneUTC: 'UTC (Coordinated Universal Time)',
      timezoneLocal: 'Local time',
      timezoneShanghai: 'Beijing/Shanghai (UTC+8)',
      timezoneTokyo: 'Tokyo (UTC+9)',
      timezoneLosAngeles: 'Los Angeles (UTC-8/-7)',
      timezoneNewYork: 'New York (UTC-5/-4)',
      timezoneLondon: 'London (UTC+0/+1)',
      timezoneSydney: 'Sydney (UTC+10/+11)',
      timezoneSingapore: 'Singapore (UTC+8)',
    },
  },
};

export const USER_PROFILE_NAMESPACE = 'userProfile';

export const USER_PROFILE_RESOURCE_KEY = 'template';

export const USER_PROFILE_I18N_RESOURCES: Record<
  AppLanguage,
  Record<typeof USER_PROFILE_RESOURCE_KEY, UserProfileI18nTemplate>
> = {
  zh: {
    [USER_PROFILE_RESOURCE_KEY]: TEMPLATES.zh,
  },
  en: {
    [USER_PROFILE_RESOURCE_KEY]: TEMPLATES.en,
  },
};

export const getUserProfileTemplate = (
  language: AppLanguage = getPreferredLanguage(),
): UserProfileI18nTemplate => TEMPLATES[language] || TEMPLATES.zh;
